@if (photos().length > 0) {
<button class="thumbnail-btn" type="button"
  [attr.aria-label]="hasMultiple() ? 'View ' + photos().length + ' photos' : 'View photo'"
  data-testid="photo-thumbnail-btn" (click)="openLightbox()">
  <img [src]="photos()[0]" alt="Photo" class="thumbnail-img" loading="lazy" data-testid="photo-thumbnail-img" />

  @if (hasMultiple()) {
  <span class="multi-badge" aria-hidden="true" data-testid="photo-multi-badge">
    <svg class="multi-icon" viewBox="0 0 16 12" fill="currentColor" aria-hidden="true">
      <rect x="0" y="3" width="10" height="8" rx="1.5" opacity="0.45" />
      <rect x="2" y="1.5" width="10" height="8" rx="1.5" opacity="0.7" />
      <rect x="4" y="0" width="10" height="8" rx="1.5" />
    </svg>
    {{ photos().length }}
  </span>
  }
</button>
}